import { SearchFilterTypeEnum } from "@components/atoms/Filters/utils";
import { BreadCrumbLabel } from "@components/molecules/Breadcrumbs/utils";
import { PriceModes } from "@components/molecules/PriceModeCard/types";
import Routes from "@navigations/Routes";
import { navigate, push } from "@navigations/utils/RootNavigation";
import { StoneType } from "@scenes/bulk-request/Utils";
import { ProductCategory } from "@utils/constants";
import { rewriteDeeplink } from "@utils/rewriteDeeplink";
import { Linking, Platform } from "react-native";

const getSectionName = (type: ProductCategory, stone_type: string) => {
  switch (type) {
    case ProductCategory.DIAMOND:
      return stone_type === StoneType.PAIR
        ? SearchFilterTypeEnum.PAIRS
        : stone_type === StoneType.PARCELS
        ? SearchFilterTypeEnum.PARCEL
        : SearchFilterTypeEnum.SINGLE_STONES;
    case ProductCategory.LAB_GROWN_DIAMOND:
      return stone_type === StoneType.PAIR
        ? SearchFilterTypeEnum.PAIRS
        : stone_type === StoneType.PARCELS
        ? SearchFilterTypeEnum.PARCEL
        : SearchFilterTypeEnum.SINGLE_STONES;
    case ProductCategory.GEMSTONE:
      return stone_type === StoneType.PAIR
        ? SearchFilterTypeEnum.PAIRS
        : stone_type === StoneType.PARCELS
        ? SearchFilterTypeEnum.PARCEL
        : SearchFilterTypeEnum.SINGLE_STONES;
    case ProductCategory.JEWELRY:
      return SearchFilterTypeEnum.JEWELRY;
    case ProductCategory.LABGROWN_JEWELRY:
      return SearchFilterTypeEnum.LAB_GROWN_JEWELRY;
    default:
      return SearchFilterTypeEnum.JEWELRY;
  }
};

const parseAndNavigate = async (link: string, products: any) => {
  try {
    if (Platform.OS === "web" && link.startsWith("vdbapp://")) {
      const normalizedLink = link.replace("vdbapp://", "https://vdbapp/");
      const url = new URL(normalizedLink);
      const savedSearchParam = url.searchParams.get("saved_search");
      const segments = link.split("://")[1]?.split("/");
      const productType = segments[0];
      if (!savedSearchParam) {
        throw new Error("saved_search parameter not found");
      }
      const params = {
        productType: productType || ProductCategory.JEWELRY,
        fromResultScreen: false,
        sectionName: getSectionName(productType),
        saved_search: savedSearchParam,
        productPrefix: products[productType]?.product_prefix,
      };
      if (Platform.OS === "web") {
        const newURL =
          "https://" +
          window.location.host +
          "/webapp/" +
          products[productType]?.product_prefix +
          "/search?priceMode=" +
          segments[1] +
          "&productType=" +
          productType +
          segments[3].replace("?", "&");
        Linking.openURL(newURL);
      } else {
        navigate(Routes.FilterSplitScreen, params);
      }
    } else {
      const newUrl = link.startsWith("vdbapp://")
        ? rewriteDeeplink(link)
        : link;
      const supported = await Linking.canOpenURL(newUrl);
      if (supported) {
        await Linking.openURL(link);
      } else {
        console.log(`Don't know how to open this URL: ${link}`);
      }
    }
  } catch (error) {
    console.error(error?.message);
  }
};

const handleItemClick = (
  item: any,
  mProductType: string,
  priceMode: number,
  productPrefix: string,
  addRouteToHistory: any,
  enterSecondFlow?: boolean,
  enableJewelryBuilder?: boolean,
  handleReset?: () => void
) => {
  const name = Routes.PDPScreen;
  const params = {
    productID: Number(item.id),
    productType: mProductType,
    priceMode: Number(priceMode),
    productPrefix: productPrefix,
    breadCrumbLabel:
      mProductType === ProductCategory.JEWELRY
        ? BreadCrumbLabel.SETTING_DETAILS
        : BreadCrumbLabel.STONE_DETAILS,
    ...(enterSecondFlow && { enterSecondFlow: enterSecondFlow }),
  };
  const route = { name, params };
  if (enableJewelryBuilder) {
    addRouteToHistory(route);
  }
  push(name, params);

  if (handleReset) {
    setTimeout(() => {
      handleReset();
    }, 50);
  }
};

const createItemDetailLink = ({
  productPrefix,
  productID,
  productType,
  priceMode,
}: any) =>
  `/webapp/${productPrefix}/item-detail/${productID}?productType=${
    productType ?? ProductCategory.DIAMOND
  }&priceMode=${priceMode ?? PriceModes.WHITE}`;

export {
  getSectionName,
  parseAndNavigate,
  handleItemClick,
  createItemDetailLink,
};
